
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type singleVehicleGarageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function singleVehicleGarageRT(): TemplateResult<singleVehicleGarageRTRootProps> {
    return _createElement('div', { 'className': 'garage-container' }, [this.changeButton(function () {
            return _createElement('div', { 'className': 'cm_changeButton' }, _createElement('span', { 'className': 'custom-garage-icon' }, _createElement('svg', {
                'width': '14',
                'height': '14',
                'viewBox': '0 0 14 14',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg'
            }, _createElement('path', {
                'd': 'M0 3L7 0L14 3V14H12V6H2V14H0V3Z',
                'fill': '#2F2F2B'
            }), _createElement('rect', {
                'x': '3',
                'y': '7',
                'width': '8',
                'height': '1',
                'fill': '#2F2F2B'
            }), _createElement('rect', {
                'x': '3',
                'y': '9',
                'width': '8',
                'height': '1',
                'fill': '#2F2F2B'
            }), _createElement('rect', {
                'x': '3',
                'y': '11',
                'width': '8',
                'height': '1',
                'fill': '#2F2F2B'
            }))), this.template === 'active' ? _createElement('div', {
                'className': 'active-container cmTemplate_active',
                'key': '418'
            }, this.name === 'VehicleWidgetDialog' ? 'Add Your Vehicle' : 'Select Your Vehicle') : null, this.template === 'locked' ? _createElement('div', {
                'className': 'locked-container cmTemplate_locked',
                'key': '634'
            }, _createElement('span', { 'className': 'model' }, this.vehicleString), _createElement('span', { 'className': 'change' }, _translate(`single_vehicle_garage_change`))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.template === 'locked' ? _createElement('div', {
        'className': 'clear-garage cmTemplate_locked',
        'key': '2028'
    }, _createElement('div', {
        'className': 'cm_button',
        'onClick': this.discardVehicle
    }, _createElement('span', {}, _translate(`single_vehicle_garage_clear`)))) : null);
}
        export const componentNames = ["cm:changeButton"]